export default __webpack_public_path__ + "static/media/img-0702-belgium-full-face.5bb88b07.png";